import { palette, mediaQueries, Button } from '@centivo/react-components'
import React from 'react'
import styled from 'styled-components'

interface FilterButtonProps {
  buttonType?: 'primary' | 'secondary' | 'tertiary'
  edgeType?: 'rounded' | 'square' | 'pill'
  slim?: boolean
  children?: React.ReactNode
  onClick?: () => void
  className?: string
}

export const FilterButton = styled(Button).attrs<FilterButtonProps>(props => ({
  buttonType: props.buttonType || 'secondary',
  edgeType: props.edgeType || 'rounded',
  slim: props.slim !== undefined ? props.slim : true,
}))`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 16px;
  width: min-content;
  height: min-content;
  padding: 0.375rem 0.5rem !important;
  margin-left: auto;
  border: 1px solid transparent;
  color: ${palette.brand.darkPurple} !important;
  background-color: #ebeff5;

  &:hover {
    background-color: ${palette.brand.lightPurple};
    box-shadow: none !important;
  }

  &:focus {
    background-color: ${palette.brand.lightPurple} !important;
    border: 1px solid ${palette.brand.newPurple};
  }

  font-weight: 500;
  border-radius: 5px;

  @media ${mediaQueries.mobile} {
    margin-left: unset;
  }

  @media ${mediaQueries.desktop} {
    grid-column: 2;
    grid-row: 1;
    margin: 0;
  }

  svg {
    margin-left: 0.5rem;
  }
`
